// extracted by mini-css-extract-plugin
export default {"modal":"kUEy2FpEnwIS3_38dP6A","titleWrapper":"vl9_FH539schRdzscqJ2","content":"T0ZbuBDoRU1DHNnM1Imw","alert":"bJc7qSIdCjWBuzs_s0vd","dateField":"OP8rJHLjGneNuki7QmA8"};